import { z } from "zod";
import { zArr, zNum, zStr, zOptional, zNullable } from "./zodWrapper.js";
import { ZDate } from "./ZDate.js";
export const BatteryUsageStatistics = z.object({
    totalHours: zNum(),
    socHigh: zNum(),
    socLow: zNum(),
    socAvg: zNum(),
});
export const BatteryUsageBatteryMode = z.object({
    spinningReserveHours: zNum(),
    peakShavingHours: zNum(),
    batteryModeHours: zNum(),
});
export const BatteryUsageTimeUsePerMode = z.object({
    opModeId: zNum(),
    timeOnPercent: zNum(),
});
export const BatteryUsageCharging = z.object({
    chargingFromDgHours: zNum(),
    chargingFromShorePowerHours: zNum(),
});
export const BatteryUsageData = z.object({
    BatteryUsageStatistics: BatteryUsageStatistics,
    BatteryUsageBatteryMode: BatteryUsageBatteryMode,
    BatteryUsageTimeUsePerMode: zArr(BatteryUsageTimeUsePerMode),
    BatteryUsageCharging: BatteryUsageCharging,
});
export const HybridSavingsInDpData = z.object({
    hoursInDP: zNum(),
    // when in DP && 1 dg running + battery on
    fuelConsumption: zNum(),
    sfocAVG: zNum(),
    hoursInDp1DG: zNum(),
    // simulated by sharing the load on 2 dgs
    simulatedFuelConsumption: zNum(),
    simulatedSfocAvg: zNum(),
});
export const HybridSavingsInPortData = z.object({
    // when in Port
    hoursInPort: zNum(),
    hoursShorePower: zNum(),
    //for dg in port
    hoursDgRunning: zNum(),
    fuelConsumption: zNum(),
    //simulated fuel consumption dg running instead of shorepower connected
    simulatedFuelConsumption: zNum(),
});
export const HybridBatteryUsageTransitDG = z.object({
    engineLabel: zStr(),
    runningHours: zNum(),
    runningHoursInTransit: zNum(),
    hoursOnBattery: zNum(),
    hoursOnBatteryInTransit: zNum(),
});
export const HybridBatteryUsageTransitMode = z.object({
    opModeId: zNum(),
    hoursInMode: zNum(),
    hoursBatteryOn: zNum(),
});
export const HybridBatteryUsageTransitData = z.object({
    generator: zArr(HybridBatteryUsageTransitDG),
    opMode: zArr(HybridBatteryUsageTransitMode),
});
export const HybridUnusedPotential = z.object({
    totalTime: zNum(),
    potentialFuelSavings: zNum(),
    co2: zOptional(zNum()),
});
export const HybridUnusedPotentialData = z.object({
    dp: HybridUnusedPotential,
    port: HybridUnusedPotential,
    transitLoadLeveling: HybridUnusedPotential,
    transitPeakShaving: HybridUnusedPotential,
});
export const HybridTimelineConsumptionCard = z.object({
    avgLoad: zNum(),
    fuelConsumption: zNum(),
});
export const HybridTimelineCalculatedCard = z.object({
    dgRunninghours: zNum(),
});
export const HybridTimelineCard = z.object({
    consumption: HybridTimelineConsumptionCard,
    simulated: HybridTimelineConsumptionCard,
    savings: HybridTimelineCalculatedCard,
});
export const HybridTimelineGetArgs = z.object({
    plantId: zNum(),
    gte: ZDate,
    lt: ZDate,
});
export const HybridEventsMetaData = z.object({
    conditionSensorsId: zArr(zNum()),
    speedSensorId: zNullable(zNum()), // TODO: don't use this property
    weatherSensorsId: zArr(zNum()),
    fuelConsumersSensorsId: zArr(zNum()),
    loadSensorsId: zArr(zNum()),
    opModeId: zNum(),
});
export const HybridEvent = z.object({
    t1: ZDate,
    t2: ZDate,
    fuelConsuption: zNum(),
    fuelSimulated: zNum(),
});
export const SavingsOpModeEventData = z.object({
    events: zArr(HybridEvent),
    metaData: HybridEventsMetaData,
});
export const UnusedPotentialOpModeEventData = z.object({
    events: zArr(HybridEvent),
    metaData: HybridEventsMetaData,
});
//# sourceMappingURL=hybrid.js.map